// src/components/MobileAppBanner.js
import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import logo from '../assets/logo.png';
import { detectMobilePlatform, APP_STORE_URL, PLAY_STORE_URL } from '../utils/storeLinks';
import '../styles/mobile-app-banner.css';

const DISMISS_KEY = 'mobileAppBannerDismissed';

const MobileAppBanner = () => {
  const [platform, setPlatform] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const detected = detectMobilePlatform();
    if (!detected) return;
    if (localStorage.getItem(DISMISS_KEY)) return;

    setPlatform(detected);
    setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setVisible(false);
  };

  if (!visible || !platform) return null;

  const storeUrl = platform === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
  const storeName = platform === 'ios' ? 'App Store' : 'Google Play';

  return (
    <div className="mobile-app-banner">
      <button
        className="mobile-app-banner-close"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>

      <img src={logo} alt="Game2Earn" className="mobile-app-banner-logo" />

      <div className="mobile-app-banner-text">
        <strong>Get the Game2Earn app</strong>
        <span>Faster, smoother, built for your phone</span>
      </div>

      <a
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mobile-app-banner-cta"
      >
        Open in {storeName}
      </a>
    </div>
  );
};

export default MobileAppBanner;
